import { Component } from '@angular/core';
import { HttpDashboardService } from '../../../service/http-dashboard.service';
import { DashboardV2ComponentPlacementDto, DashboardV2Dto } from '../../../service/dto';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { takeUntil } from 'rxjs';
import { Subject } from 'rxjs';

@Component({
	selector: 'app-dashboard',
	standalone: false,
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {
	private destroy$ = new Subject<void>();
	placements: DashboardV2ComponentPlacementDto[] = [];

	dashboard?: DashboardV2Dto;

	// grids: Grid[] = [
	// 	{ xStart: 1, yStart: 1, xEnd: 6, yEnd: 1 },
	// 	{ xStart: 7, yStart: 1, xEnd: 14, yEnd: 1 },
	// 	{ xStart: 1, yStart: 2, xEnd: 2, yEnd: 2 },
	// 	{ xStart: 1, yStart: 3, xEnd: 2, yEnd: 3 },
	// 	{ xStart: 1, yStart: 4, xEnd: 2, yEnd: 4 },
	// 	{ xStart: 4, yStart: 2, xEnd: 9, yEnd: 4 },
	// 	{ xStart: 10, yStart: 2, xEnd: 14, yEnd: 4 },
	// 	{ xStart: 1, yStart: 5, xEnd: 7, yEnd: 6 },
	// 	{ xStart: 8, yStart: 5, xEnd: 14, yEnd: 5 },
	// 	{ xStart: 10, yStart: 6, xEnd: 14, yEnd: 7 },
	// 	{ xStart: 1, yStart: 7, xEnd: 5, yEnd: 8 },
	// 	{ xStart: 6, yStart: 8, xEnd: 14, yEnd: 8 },
	// 	{ xStart: 1, yStart: 9, xEnd: 9, yEnd: 9 }
	// ];
	constructor(private httpService: HttpDashboardService, public breakpointObserver: BreakpointObserver) {
	}
	ngOnInit() {
		this.breakpointObserver.observe([
			Breakpoints.XSmall,   // < 600px
			Breakpoints.Small,    // 600–959px
			Breakpoints.Medium,   // 960–1279px
			Breakpoints.Large,    // 1280–1919px
			Breakpoints.XLarge,   // > 1920px
		])
			.pipe(takeUntil(this.destroy$))
			.subscribe(() => this.buildGrid());
		this.httpService.getMainDashboard().subscribe(result => {
			this.dashboard = result;
			this.buildGrid();
		});
	}
	buildGrid() {
		if (!this.dashboard) {
			this.placements=[];
			return;
		}
		this.placements = this.dashboard.placements.filter(item => this.isMatch(item));
	}
	isMatch(input: DashboardV2ComponentPlacementDto): boolean {
		const bo = this.breakpointObserver;

		if (bo.isMatched(Breakpoints.XSmall) && input.breakpoint == 'XS') {
			return true;
		}
		if (bo.isMatched(Breakpoints.Small) && input.breakpoint == 'SM') {
			return true;
		}
		if (bo.isMatched(Breakpoints.Medium) && input.breakpoint == 'MD') {
			return true;
		}
		if (bo.isMatched(Breakpoints.Large) && input.breakpoint == 'LG') {
			return true;
		}
		if (bo.isMatched(Breakpoints.XLarge) && input.breakpoint == 'XL') {
			return true;
		}
		return input.breakpoint == 'XXL';
	}
	get breakpoint(){

		const bo = this.breakpointObserver;
		if (bo.isMatched(Breakpoints.XSmall)) {
			return 'XSmall';
		}
		if (bo.isMatched(Breakpoints.Small)) {
			return 'Small';
		}
		if (bo.isMatched(Breakpoints.Medium)) {
			return 'Medium';
		}
		if (bo.isMatched(Breakpoints.Large)) {
			return 'Large';
		}
		if (bo.isMatched(Breakpoints.XLarge)) {
			return 'XLarge';
		}
		return 'XXLarge';
	}
}
